import { CartDiscountStates } from '~/types/CartDiscountType';

const getAllUnmatchedCoupons = (discountCodes) => {
  return discountCodes.filter((item) => item.state !== CartDiscountStates.matchesCart);
};

export { getAllUnmatchedCoupons };
